<!-- FR-002 (AC-006/AC-007): the pill is the drag HANDLE as well as the button. Nothing
     about its appearance or its accessible name changes — `left`/`top` are only bound once
     the user has actually moved it, and until then `.eb-fab`'s `right`/`bottom` gutter
     anchor is what positions it. -->
<button
  #fab
  type="button"
  class="eb-fab"
  [class.eb-fab--hidden]="store.open()"
  [class.eb-fab--placed]="position() !== null"
  [class.eb-fab--icon-only]="!store.showBubbleLabel()"
  [style.left.px]="position()?.x"
  [style.top.px]="position()?.y"
  [attr.tabindex]="store.open() ? -1 : 0"
  [attr.aria-hidden]="store.open() ? true : null"
  data-testid="button-ask-ethel"
  [attr.aria-label]="'ethel.askEthel' | transloco"
  [attr.aria-expanded]="store.open()"
  (pointerdown)="onPointerDown($event)"
  (keydown)="onKeydown($event)"
  (click)="open()"
>
  <span class="eb-avatar" aria-hidden="true">
    <svg lucideSparkles class="eb-avatar-icon"></svg>
  </span>
  @if (store.showBubbleLabel()) {
    <span class="eb-label">{{ 'ethel.askEthel' | transloco }}</span>
  }
</button>
